import type {ComponentType} from 'react';
import {hydrateRoot} from 'react-dom/client';

import {Shell, readPagePayload, type PagePropsBase} from './document';

/**
 * The client half of the SSR/hydration pair. Each Hono app ships one client bundle
 * whose registry maps page names to the same components the server rendered —
 * hydration then attaches every interactive behaviour (form handlers, modals, tabs).
 */
export function mountClient(registry: Record<string, ComponentType<any>>) {
  const {page, props} = readPagePayload<PagePropsBase>();
  const Page = registry[page];
  if (!Page) {
    throw new Error(`No client page registered for "${page}"`);
  }
  hydrateRoot(
    document,
    <Shell title={props.title} page={page} props={props}>
      <Page {...props} />
    </Shell>,
  );
}
